export default __webpack_public_path__ + "static/smile-project-570c7f17cae23c356f87ec8d617dbeb6.jpg";